import React, { Suspense } from "react";
import PropTypes from "prop-types";
import "react-toastify/dist/ReactToastify.css";
import WelcomeHeader from "../Header/WelcomeHeader";
import MainHeader from "../Header/MainHeader";
import StoreFooter from "../Footer/StoreFooter";

function StoreLayout({ children }) {
  return (
    <div className="wrapper font-family-inter">
      <div className="d-flex h-100-vh">
        <div className="w-full sidebar-page">
          {/* <WelcomeHeader /> */}
          {/* <MainHeader /> */}
          <Suspense>
            <div className="child_wrapper padding-24">{children}</div>
          </Suspense>
          <StoreFooter />
        </div>
      </div>
    </div>
  );
}

StoreLayout.propTypes = {
  children: PropTypes.any,
  pageTitle: PropTypes.string,
  description: PropTypes.string,
};

StoreLayout.defaultProps = {
  children: {},
};

export default StoreLayout;
